import { NgModule }       from '@angular/core';
import { CommonModule }   from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AdministrationRoutingModule }       from './administration-routing.module';
import { ClarityModule } from '@clr/angular';
import { VcaCommonModule } from '../../../common';
import AdministrationMain from './administration-main.component';
import { ResizableModule } from 'angular-resizable-element';
import { DeploymentContainerLanding } from './deployment-container/dc-landing.component';
import { AddEditDeploymentContainerDialog } from './deployment-container/dialog/add-edit-dc.component';
import { SelectEntityDialogComponent } from './deployment-container/dialog/select-entity-dialog.component';
import { TranslateModule } from '@ngx-translate/core';

import { DCTreeMain } from './deployment-container/dc-tree/dc-tree-main.component';
import { DCTreeHolder } from './deployment-container/dc-tree/dc-tree-holder.component';
// import { InterConnectConfigurationLanding } from './interconnect-configuration/icc-landing.component';
import { InterConnectConfigurationLanding } from './interconnect-configuration/icc-landing.component';
import { CreateICCWizard } from './interconnect-configuration/wizard/create-icc-wizard';
import { SelectVCDC } from './interconnect-configuration/wizard/steps/select-vc-dc.component';
import { SelectNetworkProfiles } from './interconnect-configuration/wizard/steps/select-network-profiles.component';
import { ReadyToComplete } from './interconnect-configuration/wizard/steps/ready-to-complete.component';
import { NetworkProfile } from './interconnect-configuration/wizard/network-profile/network-profile.component';
import { AddNetwork } from './interconnect-configuration/dialog/add-network.component';
import { EditNetwork } from './interconnect-configuration/dialog/edit-network.component';
import { StaticRouteConfiguration } from './interconnect-configuration/wizard/steps/static-route-configuration.component';
import { SupportComponent } from './support/support.component';
import { DiceIntegrationComponent } from '../administration-main/dice-integration/dice-integration.component';


import { ICCService } from './interconnect-configuration/icc.service';
import { FormatIPsPipe } from './interconnect-configuration/format-ip-pipe';
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        AdministrationRoutingModule,
        VcaCommonModule,
        ClarityModule.forRoot(),
        ResizableModule,
        TranslateModule
    ],
    declarations: [
        AdministrationMain,
        DeploymentContainerLanding,
        AddEditDeploymentContainerDialog,
        SelectEntityDialogComponent,
        DCTreeMain,
        DCTreeHolder,
        InterConnectConfigurationLanding,
        CreateICCWizard,
        SelectVCDC,
        SelectNetworkProfiles,
        ReadyToComplete,
        NetworkProfile,
        AddNetwork,
        EditNetwork,
        StaticRouteConfiguration,
        FormatIPsPipe,
        SupportComponent,
        DiceIntegrationComponent
    ],
    providers: [ICCService]
})
export class AdministrationModule {
}



// WEBPACK FOOTER //
// ./src/app/components/administration-main/administration.module.ts